import { useApolloClient } from '@apollo/client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { OIL_DISPOSAL_SERVICE_NAME } from '../../config/constants';
import { routeStateAtom } from '../../services/recoil/atoms/routeState';
import AddStopModal from '../molecules/AddStopModal';
import StopsList from './StopsList';

function RouteOnList() {
  const { t } = useTranslation();
  const route = useRecoilValue(routeStateAtom);
  const apolloClient = useApolloClient();
  const [addStopOpen, setAddStopOpen] = useState(false);

  return (
    <div className="z-20 flex w-full flex-col items-center justify-center overflow-y-auto rounded-t-3xl bg-appBG">
      <div className="flex w-[92vw] flex-col items-center justify-center gap-3 py-2">
        <StopsList />
        {route?.service === OIL_DISPOSAL_SERVICE_NAME && (
          <button
            className="border-reyesgreen text-reyesgreen flex w-full items-center justify-center gap-2 rounded-lg border bg-white px-4 py-3 text-sm font-semibold"
            onClick={() => setAddStopOpen(true)}
          >
            + {t('dashboard.addStop')}
          </button>
        )}
      </div>
      {addStopOpen && route?.id && (
        <AddStopModal
          routeId={route.id}
          onClose={() => setAddStopOpen(false)}
          onStopAdded={async () => {
            await apolloClient.refetchQueries({
              include: ['GetRouteByDriver'],
            });
            setAddStopOpen(false);
          }}
        />
      )}
    </div>
  );
}

export default RouteOnList;
